import { NgModule } from '@angular/core';
import { TaxParamService } from './tax-param.service';

@NgModule({
    providers: [TaxParamService]
})
export class TaxParamModule {
    constructor(private taxParamService: TaxParamService) {
        this.taxParamService.setTaxBasedOnUrlParam();
    }
}
